import React from 'react'
import Favicon from '../SEO/favicon'

const SEOEmb = ({ title, canonical }) => {
  return (
    <>
      <title>{title}</title>
      <link rel="canonical" href={canonical}></link>
      <Favicon />
    </>
  )
}

export default SEOEmb
